module.exports = __webpack_public_path__ + "static/media/HCRA Notice of Proposal to Make Compliance Order - Marjan Homes Inc. - December 9- 2024.453cba2b.pdf";